import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import ReactStars from "react-rating-stars-component";
import {
  setDevice,
  setDropdownOpen,
  setIsModalOpen,
  setLinkModal,
} from "../../../redux/slices/BwvData";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { MdVideoChat } from "react-icons/md";
import GitHubForkRibbon from "react-github-fork-ribbon";
import { Button, Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { makeCall, sendMsgMail, twilioToken, virtualTourClick } from "../Data";
import { GetZoomLink } from "../Data2";
import { FaLocationArrow } from "react-icons/fa";
import { countryCodes } from "../../CountryCodes";
import Select from "react-select";
import VendorMaps from "./vendorMaps";
import MsgModal from "../modals/MsgModal";
import axiosClient from "../../../axios-client";
import {
  checkExisting,
  handleActionClick,
  setActionType,
  setIsMsgModalOpen,
  setSampleAd,
  setSearchPopUp,
} from "../../../redux/slices/SearchBarSlice";
import { setEngagedCouple } from "../../../redux/slices/RequestFormSlice";
import { Helmet } from "react-helmet";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { FadeLoader } from "react-spinners";
import moment from "moment";
import { styled } from "@mui/material/styles";
import { listCustomerInteractionsAdmin } from "../Data3";
import VendorProfileLinks from "./VendorProfileLinks";
import AutoNeedModal from "../LocalCummunityAds/AutoNeed/AutoNeedModal";

const VendorProfileDt = () => {
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const selectedCard = useSelector((state) => state.bwvData.selectedService);
  const formData = useSelector((state) => state.requestForm);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isInCall, setIsInCall] = useState(false);
  const { device, viewers, viewCount, dropdownOpen, isModalOpen } = useSelector(
    (state) => state.bwvData
  );
  const {
    sampleAd,
    isMsgModalOpen,
    actionClickStatus,
    actionClickError,
    checkExistingError,
    checkExistingStatus,
    searchPopUp,
    actionType, // Added to check actionType
  } = useSelector((state) => state.searchBar);
  const isAdmin = user && user.Role === "admin";
  const logUser = localStorage.getItem("USER_ROLE");
  const isVendor = logUser === "provider";
  const [mobileModalOpen, setMobileModalOpen] = useState(false);
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState("+1");
  const countryOptions = countryCodes.map((country) => ({
    label: `${country.name} (${country.dial_code}) `,
    value: country.dial_code,
  }));

  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [customerInteractions, setCustomerInteractions] = useState(false);
  useEffect(() => {
    const fetchCustomer = async () => {
      setLoading(true);
      const response = await listCustomerInteractionsAdmin();
      console.log(response, "response");
      setLoading(false);
      setCustomers(response);
    };

    isAdmin && fetchCustomer();
  }, []);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    let hasFbclid = queryParams.has("fbclid");
    if (!hasFbclid) {
      const urlParts = window.location.href.split("#")[0];
      const queryString = urlParts.includes("?") ? urlParts.split("?")[1] : "";
      const manualParams = new URLSearchParams(queryString);
      hasFbclid = manualParams.has("fbclid") || queryString.includes("fbclid=");
    }
    if (hasFbclid && selectedCard?.Id && !isAdmin && !isVendor) {
      const timer = setTimeout(() => {
        console.log("Dispatching popup actions for fbclid after delay");
        dispatch(setSampleAd(selectedCard));
        dispatch(setActionType("FROMLINK"));
        dispatch(setSearchPopUp(true));
        dispatch(setEngagedCouple(1));
      }, 5000); // 5-second delay

      // Cleanup the timer on component unmount or if the effect re-runs
      return () => clearTimeout(timer);
    }
  }, [location.search, selectedCard?.Id, dispatch]);

  const handleCodeChange = (value) => {
    setSelectedCountry(value);
  };

  useEffect(() => {
    if (!searchPopUp && !isModalOpen && !isMsgModalOpen && actionType) {
      const timer = setTimeout(() => {
        console.log("Opening StartZoomVendorModal after 6-second delay");
        dispatch(setLinkModal(true));
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [searchPopUp, isModalOpen, isMsgModalOpen, actionType, dispatch]);

  useEffect(() => {
    if (actionClickStatus === "failed" && actionClickError) {
      toast.error(actionClickError);
    }
  }, [actionClickStatus, actionClickError]);

  useEffect(() => {
    if (checkExistingStatus === "failed" && checkExistingError) {
      toast.error(checkExistingError);
    }
  }, [checkExistingStatus, checkExistingError]);

  const handleAction = async (action) => {
    dispatch(setSampleAd(selectedCard));
    dispatch(setActionType(action));
    if (searchPopUp) {
      toast.info("Please complete the current action before proceeding.");
      return;
    }
    let needExists = false;
    if (islogin) {
      const constructedTitle = selectedCard?.listName + " (Auto Generated)";
      const checkForm = {
        Title: constructedTitle,
        userId: user?.UserID,
      };
      const result = await dispatch(checkExisting(checkForm)).unwrap();
      needExists = result.data;
    }
    if (isAdmin || isVendor || needExists) {
      if (action === "CALL") {
        const phoneNumber = selectedCard?.Phone;
        const url = `tel:${phoneNumber}`;
        window.location.href = url;
      } else if (action === "TEXT") {
        dispatch(setIsMsgModalOpen(true));
      } else if (action === "HIRE") {
        dispatch(setIsModalOpen(true));
      } else if (action === "VIRTUAL") {
        dispatch(setDropdownOpen(true));
      }
      return;
    }
    if (islogin) {
      const form = {
        userId: user.UserID,
        postId: selectedCard.Id,
        postType: 2,
        clickType:
          action === "CALL"
            ? 1
            : action === "TEXT"
            ? 2
            : action === "HIRE"
            ? 4
            : 5,
        createdBy: user.UserID,
      };
      dispatch(handleActionClick(form));
    }
    dispatch(setSearchPopUp(true));
    dispatch(setEngagedCouple(1));
  };

  function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }

  const now = new Date();
  const formattedDate = formatDate(now);

  const handleClick = async () => {
    if (!islogin && !name) {
      toast.error("Please Enter Email");
      return;
    }
    if (!islogin && !phoneNumber) {
      toast.error("Please Enter Phone Number");
      return;
    }
    if (!islogin && !selectedCountry) {
      setSelectedCountry("+1");
    }
    const serviceInfo = JSON.parse(selectedCard?.additionalPeople);
    const newPerson1 = {
      email: !islogin ? name : user?.Email,
      phoneNumber: !islogin ? phoneNumber : user?.Phone,
      countryCode: !islogin ? selectedCountry : user?.CountryCode,
    };
    let newPerson2;
    let newPerson3;
    if (selectedCard.profilePhone === selectedCard.Phone) {
      newPerson2 = {
        email: selectedCard?.Email,
        phoneNumber: selectedCard?.profilePhone,
        countryCode: selectedCard?.countryCode,
      };
    } else {
      newPerson2 = {
        email: selectedCard?.Email,
        phoneNumber: selectedCard?.profilePhone,
        countryCode: selectedCard?.countryCode,
      };
      newPerson3 = {
        email: selectedCard?.Email,
        phoneNumber: selectedCard?.Phone,
        countryCode: selectedCard?.countryCode,
      };
    }
    serviceInfo.unshift(newPerson1);
    serviceInfo.push(newPerson2);
    if (newPerson3) {
      serviceInfo.push(newPerson3);
    }
    const stringifiedAdditionalPeople = JSON.stringify(serviceInfo);
    let formData = {
      email: !islogin ? name : user?.Email,
      phoneNumber: !islogin ? phoneNumber : user?.Phone,
      countryCode: !islogin ? selectedCountry : user?.CountryCode,
      phoneDetails: stringifiedAdditionalPeople,
      similarLocalVendor: selectedCard?.similarLocalVendor,
      customerName: `${user?.FirstName} ${user?.LastName}`,
      serviceId: selectedCard?.Id,
      customerId: user?.UserID,
    };
    const response = await makeCall(formData);
    toast.success(
      "We will be sending you a text message link to join the meeting within 30 seconds"
    );
    if (response === "initiating call") {
      const formData = {
        startTime: formattedDate,
        needName: selectedCard?.listName,
      };
      const linkResponse = await GetZoomLink(formData, selectedCard?.Id);
      let formData1 = {
        zoomlink: linkResponse.join_url,
        phoneDetails: stringifiedAdditionalPeople,
        customerId: user?.UserID,
        ownerId: parseInt(selectedCard?.createdBy),
        Type: "details",
        postId: selectedCard?.Id,
        postName: selectedCard?.listName,
      };
      await sendMsgMail(formData1);
      await virtualTourClick(selectedCard?.Id);
    } else {
      throw new Error("Response from makeCall was invalid");
    }
  };

  const handleCallButtonClick = async () => {
    const serviceInfo = JSON.parse(selectedCard?.additionalPeople);
    let newPerson2;
    let newPerson3;
    if (selectedCard.profilePhone === selectedCard.Phone) {
      newPerson2 = {
        email: selectedCard?.Email,
        phoneNumber: selectedCard?.Phone,
        countryCode: selectedCard?.countryCode,
      };
    } else {
      newPerson2 = {
        email: selectedCard?.Email,
        phoneNumber: selectedCard?.Phone,
        countryCode: selectedCard?.countryCode,
      };
      newPerson3 = {
        email: selectedCard?.Email,
        phoneNumber: selectedCard?.profilePhone,
        countryCode: selectedCard?.countryCode,
      };
    }
    if (newPerson3) {
      serviceInfo.unshift(newPerson3);
    }
    serviceInfo.unshift(newPerson2);
    const combinedInfo = serviceInfo
      .map((item) =>
        item.phoneNumber
          ? `${item.countryCode}${item.phoneNumber}`
          : item.phoneNumber
      )
      .filter((item) => item);
    try {
      const response = await twilioToken("111111");
      const newDevice = await new window.Twilio.Device(response.token);
      dispatch(setDevice(newDevice));
      newDevice.on("ready", () => {});
      newDevice.on("error", (error) => {});
      const roomName = "room1";
      combinedInfo.map(async (phoneNumber) => {
        await newDevice.connect({
          params: JSON.stringify({
            To: phoneNumber,
            callerId: "+18664520710",
            intent: "dial",
            serviceId: selectedCard.Id,
          }),
        });
      });
      setIsInCall(true);
    } catch (error) {
      console.error("Error during call initiation:", error);
    }
  };

  const handleLinkModal = () => {
    console.log("handleLinkModal called, searchPopUp:", searchPopUp);
    if (searchPopUp) {
      toast.info(
        "Please complete the current action before starting a virtual tour."
      );
      return;
    }
    dispatch(setLinkModal(true));
  };

  const handleMobileDevice = () => {
    if (!islogin) {
      setMobileModalOpen(true);
    } else {
      handleClick();
    }
  };

  const handleDisconnectButtonClick = () => {
    if (device) {
      device.disconnectAll();
      setIsInCall(false);
    }
  };

  // Guard clause to prevent rendering if selectedCard is not available
  if (!selectedCard?.Id) {
    return <div>Loading vendor details...</div>;
  }

  return (
    <>
      {/* Dynamic Meta Tags for Facebook Sharing */}
      <Helmet>
        <meta
          property="og:title"
          content={selectedCard?.listName || "Service"}
        />
        <meta
          property="og:description"
          content={selectedCard?.description || "Check out this great service!"}
        />
        <meta
          property="og:image"
          content={
            selectedCard?.Photo
              ? (() => {
                  try {
                    const photos = JSON.parse(selectedCard.Photo);
                    return Array.isArray(photos) && photos.length > 0
                      ? photos[0]
                      : "https://letsenhance.io/static/73136da51c245e80edc6ccfe44888a99/1015f/MainBefore.jpg";
                  } catch (error) {
                    console.error("Error parsing selectedCard.Photo:", error);
                    return "https://letsenhance.io/static/73136da51c245e80edc6ccfe44888a99/1015f/MainBefore.jpg";
                  }
                })()
              : "https://letsenhance.io/static/73136da51c245e80edc6ccfe44888a99/1015f/MainBefore.jpg"
          }
        />
        <meta
          property="og:url"
          content={`${process.env.REACT_APP_URL}/#/vendordetails/${selectedCard.Id}`}
        />
        <meta property="og:type" content="service" />
      </Helmet>
      <Row className="image">
        <div
          className="d-flex align-items-center justify-content-center p-0 position-relative blurred-background"
          style={{
            backgroundImage: `url(${
              selectedCard?.Photo
                ? JSON.parse(selectedCard?.Photo)[0]
                : "https://letsenhance.io/static/73136da51c245e80edc6ccfe44888a99/1015f/MainBefore.jpg"
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            borderRadius: "8px",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {selectedCard?.caIdStatus === 100 ? (
            <GitHubForkRibbon
              color="green"
              position="left"
              style={{ zIndex: 3 }}
            >
              Verified & Trusted
            </GitHubForkRibbon>
          ) : null}
          <img
            src={selectedCard?.Photo ? JSON.parse(selectedCard?.Photo)[0] : ""}
            alt="Selected card profile image"
            style={{
              width: "inherit",
              height: "revert-layout",
              objectFit: "contain",
              position: "relative",
              zIndex: 2,
            }}
            className="rounded"
          />
        </div>
      </Row>
      <Row className="bio-container">
        <Row style={{ cursor: "pointer", gap: 5 }}>
          <div className="">
            <h5>{selectedCard?.listName}</h5>
          </div>
          <p>
            <FaLocationArrow />
            {selectedCard?.Location || selectedCard?.serviceLocation}
          </p>
          <Col className="pb-3">
            <ReactStars
              count={5}
              size={24}
              value={selectedCard?.Rating}
              activeColor="#ffd700"
              edit={false}
            />
          </Col>
        </Row>
        {selectedCard?.Phone !== "" && selectedCard?.Phone !== null && (
          <div style={{ width: "96%" }}>
            <a
              onClick={() => handleAction("CALL")}
              className="btn btn-success btn-sm mb-2 w-100 text-center"
            >
              CALL NOW: {selectedCard?.Phone} <br />
            </a>
          </div>
        )}
        <Row>
          {/******************* Commented hire button disabled for temprary **************/}
          {/* <Col xs={12} sm={12} md={12} lg={6} xl={6} className="mb-2 pe-1">
            <button
              type="button"
              className="btn btn-primary btn-sm w-100"
              style={{ fontSize: "small" }}
              onClick={() => handleAction("HIRE")}
            >
              Hire
            </button>
          </Col> */}
          <Col
            // xs={12}
            // sm={12}
            // md={12}
            // lg={6}
            // xl={6}
            className="mb-2 pe-1"
            style={{ textWrap: "nowrap" }}
          >
            <button
              type="button"
              className="btn btn-primary btn-sm w-100"
              style={{ fontSize: "small" }}
              onClick={() => handleAction("TEXT")}
            >
              Send Message
            </button>
          </Col>
        </Row>
        <Row className="d-flex justify-content-center call_button">
          {parseInt(selectedCard?.createdBy) !== parseInt(user?.UserID) &&
            selectedCard?.customerToVenue === 1 && (
              <>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="d-flex justify-content-center mt-2"
                >
                  <Dropdown
                    isOpen={dropdownOpen}
                    toggle={() => {
                      if (dropdownOpen) {
                        dispatch(setDropdownOpen(!dropdownOpen));
                        dispatch(setSearchPopUp(false));
                        dispatch(setActionType(null));
                        dispatch(setEngagedCouple(null));
                      } else {
                        handleAction("VIRTUAL");
                      }
                    }}
                  >
                    <DropdownToggle
                      caret
                      color="success"
                      size="md"
                      className="w-100 ms-2 dropdown_button"
                      style={{ fontSize: "medium" }}
                    >
                      Start Virtual Tour
                    </DropdownToggle>
                    <DropdownMenu className="virtualDropdown">
                      <Row className="px-1 py-2">
                        <Col className="text-center px-1 py-2">
                          <MdVideoChat size={50} style={{ color: "#0097CD" }} />
                          <h3 className="mb-2">Video Call</h3>
                          <Row>
                            <Col sm={12} lg={12}>
                              <button
                                className="btn btn-sm btn-primary"
                                style={{ cursor: "pointer" }}
                                onClick={handleLinkModal}
                              >
                                Connect via website
                              </button>
                            </Col>
                            <Col sm={12} lg={12}>
                              <button
                                className="btn btn-sm btn-primary mt-2"
                                style={{ cursor: "pointer" }}
                                onClick={handleMobileDevice}
                              >
                                Connect via mobile device
                              </button>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </DropdownMenu>
                  </Dropdown>
                </Col>
              </>
            )}
        </Row>
        <div className="text-center hidden">
          {isInCall && <div className="my-2">Calling Vendor...</div>}
          {isInCall && (
            <Button
              color="danger"
              onClick={handleDisconnectButtonClick}
              className="my-2"
            >
              Disconnect Call
            </Button>
          )}
        </div>
        {isAdmin && (
          <Row>
            <div className="my-2 text-center">
              No. of Interactions:{" "}
              <b
                onClick={() => setCustomerInteractions(true)}
                style={{
                  cursor: "pointer",
                  textDecoration: "underline",
                  color: "blue",
                }}
              >
                {customers.length}
              </b>
            </div>
          </Row>
        )}
        <Row className="d-flex justify-content-between align-items-center mb-2 mt-0">
          <h6 className="p-1">Special Offer</h6>
          <p>{selectedCard?.specialOffer}</p>
        </Row>
        <Row className="mt-1">
          <p>
            <b>Bio</b>
          </p>
          <span>{selectedCard?.Bio}</span>
        </Row>
        <VendorProfileLinks handleAction={handleAction} />
      </Row>
      <VendorMaps
        location={selectedCard?.Location || selectedCard?.serviceLocation}
      />
      <Modal
        isOpen={mobileModalOpen}
        toggle={() => {
          setMobileModalOpen(false);
          setName("");
          setSelectedCountry("+1");
          setPhoneNumber(null);
        }}
      >
        <ModalBody>
          <div className="">
            <FormGroup>
              <Label>
                Email<b className="text-danger">*</b>
              </Label>
              <Input
                type="email"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <Row className="mt-2">
                <Col sm={4}>
                  <Label>Country Code:</Label>
                  <FormGroup>
                    <div className="d-flex align-items-center login-ctr-select">
                      <Select
                        options={countryOptions}
                        name="CountryCode"
                        placeholder="Select"
                        value={
                          selectedCountry
                            ? {
                                label: selectedCountry,
                                value: selectedCountry,
                              }
                            : null
                        }
                        onChange={(selectedOption) => {
                          handleCodeChange(selectedOption.value);
                        }}
                        className="w-100"
                      />
                    </div>
                  </FormGroup>
                </Col>
                <Col sm={8}>
                  <FormGroup>
                    <Label>
                      Phone Number <b className="text-danger">*</b>
                    </Label>
                    <Input
                      type="text"
                      value={phoneNumber}
                      onChange={(e) => {
                        const { value } = e.target;
                        const isValidPhone = /^\d{0,10}$/.test(value);
                        if (isValidPhone) {
                          setPhoneNumber(value);
                        }
                      }}
                      maxLength={10}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </FormGroup>
            <div className="text-center">
              <Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mb: 2 }}
                onClick={handleClick}
              >
                Start Virtual Tour Now
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <MsgModal
        isOpen={isMsgModalOpen}
        closeModal={() => dispatch(setIsMsgModalOpen(false))}
        selectedCard={selectedCard}
        userDetails={user}
      />
      {searchPopUp && <AutoNeedModal />}
      <Modal
        isOpen={customerInteractions}
        toggle={() => setCustomerInteractions(false)}
        size="lg"
      >
        <ModalBody>
          {" "}
          {loading ? (
            <FadeLoader // FadeLoader component
              color={"#36D7B7"}
              loading={loading}
              style={{ top: "30%" }}
              className="position-absolute translate-middle start-50"
            />
          ) : (
            <>
              <h3 className="text-center my-3">Customer Initiated</h3>
              <TableContainer
                component={Paper}
                sx={{
                  overflowX: "scroll",
                  overflowY: "scroll",
                }}
              >
                <Table
                  sx={{ overflowX: "scroll" }}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Initiated On</StyledTableCell>
                      <StyledTableCell>User Name</StyledTableCell>
                      <StyledTableCell>Profile Link</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  {customers.length !== 0 ? (
                    <TableBody className="">
                      {customers.map((customer, i) => (
                        <StyledTableRow
                          key={i}
                          sx={{
                            "&:last-child td, &:last-child th": {
                              border: 0,
                            },
                          }}
                        >
                          <StyledTableCell>
                            {moment(
                              customer.interaction_date.split("T")[0]
                            ).format("MMMM DD, YYYY")}
                            {moment(
                              customer.interaction_date.split("T")[1],
                              "HH:mm:ss"
                            ).format(" [at] h:mm A")}
                          </StyledTableCell>
                          <StyledTableCell>
                            {`${customer?.first_name} ${customer?.last_name}`}
                          </StyledTableCell>
                          <StyledTableCell>
                            <div
                              style={{
                                cursor: "pointer",
                                textDecoration: "underline",
                                color: "#007bff",
                                fontWeight: "bold",
                              }}
                              onClick={() =>
                                navigate(
                                  `/userDetails/${customer?.customer_id}`
                                )
                              }
                            >
                              Click here
                            </div>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  ) : (
                    <TableBody className="">
                      <StyledTableRow colSpan={5}>
                        <StyledTableCell
                          colSpan={5}
                          align="center"
                          style={{ fontSize: "larger" }}
                        >
                          No Calls Initiated
                        </StyledTableCell>
                      </StyledTableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default VendorProfileDt;
